module.exports = __webpack_public_path__ + "img/DesignIcon.85bdbcf9.png";